import React from "react";
import { View, StyleSheet } from "@react-pdf/renderer";
import TableHourHeader from "../tableHour/TableHourHeader";
import TableHourRow from "../tableHour/TableHourRow";

const styles = StyleSheet.create({
  tableContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    marginTop: 10,
  },
});

const TableHour = ({ invoice }) => {
  return (
    <View style={styles.tableContainer}>
      <TableHourHeader />
      <TableHourRow items={invoice.items} />
    </View>
  );
};

export default TableHour;
